<div class="divider-bar mb-21 mct-flex mct-row mct-justify-end mct-items-center">
  <span *ngIf="!searchResult?.TotalCount; else resultsReturned" class="no-results">
    {{ 'common.no-search-results' | translate | ucfirst }}
  </span>
  <ng-template #resultsReturned>
    <span>{{ 'common.the-search-returned' | translate | ucfirst }}</span>
    &nbsp;
    <span class="f-wb">{{ searchResult.TotalCount }}</span>
    &nbsp;
    <span class="f-wb">{{ 'committees.search.committees' | translate }}</span>
  </ng-template>
  <button type="button" class="mct-flex ml-10 atlas-btn atlas-btn-secondary mct-justify-center mct-items-center" type="button" (click)="clear()">
    <i class="large-icon pi pi-times"></i>
    <span>{{ 'common.clear-search' | translate | uppercase }}</span>
  </button>
</div>

<div class="atlas-table">
  <p-table [showGridlines]="true"
    [value]="searchResult?.Result"
    [paginator]="true"
    [rows]="searchParams ? searchParams.PageSize : 20"
    [totalRecords]="searchResult?.TotalCount"
    (onLazyLoad)="lazyLoad($event)"
    [loading]="loading"
    [lazy]="true"
  >
    <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
      <SortAltIcon *ngIf="sortOrder === 0">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
      </SortAltIcon>
      <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
      </SortAmountUpAltIcon>
      <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
      </SortAmountDownIcon>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="Name">
          {{ 'committees.search.name' | translate | ucfirst }}
          <p-sortIcon field="Name"></p-sortIcon>
        </th>
        <th pSortableColumn="CommitteeType">
          {{ 'committees.search.type' | translate | ucfirst }}
          <p-sortIcon field="CommitteeType"></p-sortIcon>
        </th>
        <th pSortableColumn="Active" class="t-ac" [style]="{ width: '120px' }">
          {{ 'committees.search.active' | translate | ucfirst }}
          <p-sortIcon field="Active"></p-sortIcon>
        </th>
        <th pSortableColumn="StartDate" class="t-ac" [style]="{ width: '120px' }">
          {{ 'committees.search.start-date' | translate | ucfirst }}
          <p-sortIcon field="StartDate"></p-sortIcon>
        </th>
        <th pSortableColumn="EndDate" class="t-ac" [style]="{ width: '120px' }">
          {{ 'committees.search.end-date' | translate | ucfirst }}
          <p-sortIcon field="EndDate"></p-sortIcon>
        </th>
        <th pSortableColumn="OnGoing" class="t-ac" [style]="{ width: '120px' }">
          {{ 'committees.search.ongoing' | translate | ucfirst }}
          <p-sortIcon field="OnGoing"></p-sortIcon>
        </th>
        <th [style]="{ width: '120px' }"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-committee>
      <tr>
        <td>
          <a [routerLink]="['/profiles/committee', committee.CommitteeID]"> {{ committee.Name }} </a>
        </td>
        <td>
          {{ committee.CommitteeType }}
        </td>
        <td class="t-ac">
          <p-checkbox binary="true" [(ngModel)]="committee.Active" (onChange)="committeeChanged(committee)"></p-checkbox>
        </td>
        <td class="t-ac">
          {{ committee.StartDate | date: 'MM/dd/yyyy' }}
        </td>
        <td class="t-ac">
          <ng-container *ngIf="!committee.OnGoing">{{ committee.EndDate | date: 'MM/dd/yyyy' }}</ng-container>
        </td>
        <td class="t-ac">
          <p-checkbox binary="true" [(ngModel)]="committee.OnGoing" (onChange)="committeeChanged(committee)"></p-checkbox>
        </td>
        <td class="t-ac">
          <action-button [label]="'common.actions' | translate | uppercase" [items]="actionItemsForCommittee(committee)"> </action-button>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <div style="margin-top: -3.3em; float: left">
    <p-select [options]="pagingSizeItems" [(ngModel)]="searchParams.PageSize" (ngModelChange)="pageSizeChanged()" appendTo="body">
    </p-select>
  </div>
</div>

<p-confirmDialog
  #cd
  key="deleteCommitteeCD"
  header="{{ 'committees.search.confirm-delete-header' | translate | titlecase }}"
  icon="pi pi-exclamation-triangle"
>
  <ng-template pTemplate="footer">
    <button type="button" class="atlas-btn atlas-btn-secondary mr-10" (click)="cd.onReject()">
      {{ 'common.cancel' | translate | uppercase }}
    </button>
    <button type="button" class="atlas-btn atlas-btn-primary" (click)="cd.onAccept()">
      {{ 'common.delete' | translate | uppercase }}
    </button>
  </ng-template>
</p-confirmDialog>
